export default "__VITE_ASSET__CFxQP1pW__"